import { render, staticRenderFns } from "./Uebersicht.vue?vue&type=template&id=4913f9ae&scoped=true"
import script from "./Uebersicht.vue?vue&type=script&lang=ts"
export * from "./Uebersicht.vue?vue&type=script&lang=ts"
import style0 from "./Uebersicht.vue?vue&type=style&index=0&id=4913f9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913f9ae",
  null
  
)

export default component.exports